export enum FileType {
  Pdf = 'application/pdf',
  Zip = 'application/x-zip-compressed', // For Chrome Browser
  Zip2 = 'application/zip', // For Safari Browser
  Csv = 'application/vnd.ms-excel', // For Chrome Browser
  Csv2 = 'text/csv', // For Safari Browser
  Png = 'image/png',
  Jpg = 'image/jpeg',
  Gif = 'image/gif',
  Bmp = 'image/bmp',
  WebP = 'image/webp',
}
